export default function SearchService(DataService, utils) {
	"ngInject";


	const separatorCommon = /[\.,\s!;?:"\u3000]+/,
		defaultSearchTypes = ["ZONE", "DISTRICT", "AREA", "CUSTOM"];

	const matches = (value, term) => (
		value.toLowerCase().indexOf(term) !== -1
	);

	const matchesAll = (value, terms) => {
		for (let i = 0; i < terms.length; i++) {
			if (!matches(value, terms[i])) {
				return false;
			}
		}
		return true;
	};


	const SearchService = {
		search: (query, searchTypes = defaultSearchTypes) => (
			DataService.getOrgsByTypes(searchTypes).then((orgs) => {
				let terms = SearchService.separateTerms(query),
					id = +query,
					matches = orgs.filter((org) => (
						matchesAll(org.name, terms) || org.id === id
					));

				matches.sort(utils.sortOrgs);

				return matches;
			})
		),
		separateTerms: (query) => {
			let results = [],
				words = query.toLowerCase().split(separatorCommon);
			words.forEach((word) => {
				if (word && results.indexOf(word) === -1) {
					results.push(word);
				}
			});
			results.sort((a, b) => (
				b.length - a.length
			));
			return results;
		},
		markTerms: (value, query) => {
			let result = value;
			if (value && query) {
				let compare = value.toLowerCase(),
					terms = SearchService.separateTerms(query),
					marks = [];

				terms.forEach((term) => {
					term = term.toLowerCase();
					let index, start = 0;
					while ((index = compare.indexOf(term, start)) !== -1) {
						let mark = {a: index, z: index + term.length},
							merged = false;
						for (let i = 0; i < marks.length; i++) {
							let current = marks[i];
							if ((current.a <= mark.a && mark.a <= current.z) || (current.a <= mark.z && mark.z <= current.z)) {
								current.a = Math.min(current.a, mark.a);
								current.z = Math.max(current.z, mark.z);
								merged = true;
								break;
							}
						}
						if (!merged) {
							marks.push(mark);
						}
						start = index + term.length;
					}
				});
				marks.sort((a, b) => (
					b.a - a.a
				));

				marks.forEach((mark) => {
					result = result.slice(0, mark.a) + "<mark>" + result.slice(mark.a, mark.z) + "</mark>" + result.slice(mark.z);
				});
			}
			return result;
		}
	};

	return SearchService;
}
